exports = module.exports = require("../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".compare-btn{font-size:18px;color:#f2994a;border-radius:2vw;width:175px;height:46px;border:1px solid #f2994a;transition:all .4s ease}.compare-btn:hover{background:linear-gradient(180deg,#eeab00,#ed5961);color:#fff}body[dir=rtl] .compare-btn:hover {\n  background: linear-gradient(-180deg,#eeab00,#ed5961);\n}\n", ""]);

// exports
